export const roles = {
  SUPERADMINISTRATOR: "SuperAdministrator",
  GLOBALVIEWER: "GlobalViewer",
  ADMINISTRATOR: "Administrator",
  QA: "QA",
  RECRUITER: "Recruiter",
};
